import {lazy, Suspense} from "react";
import {useLocation} from "react-router-dom";
import LoadingScreen from "../../../shared/components/LoadingScreen";
import AuthGuard from "../../../shared/guards/AuthGuard";
import DashboardLayout from "../../../shared/layouts/dashboard";


const Loadable = (Component) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation();

    return (
        <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
            <Component {...props} />
        </Suspense>
    );
};
const PaymentTypes = Loadable(lazy(() => import('../view/PaymentTypes')));
const MyBankCard = Loadable(lazy(() => import('../components/MyBankCard')));

export const PaymentTypeRoutes =[
    // Dashboard Routes
    {
        path: 'dashboard',
        element: (
            <AuthGuard>
                <DashboardLayout />
            </AuthGuard>
        ),
        children: [
            { path: 'payment-types', element: <PaymentTypes /> },
            { path: 'payment-types/payment-type-card', element: <MyBankCard /> },
        ],
    },
];
